import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AddCoachMeetingDialogController } from 'dialog/add-coach-meeting-dialog/add-coach-meeting-dialog.controller';
import { AddCoachMeetingDialogStore } from 'dialog/add-coach-meeting-dialog/add-coach-meeting-dialog.store';
import { SelectItem } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IUser } from 'user/user';

@Component({
	selector: 'spr-add-coach-meeting-dialog',
	templateUrl: './add-coach-meeting-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [AddCoachMeetingDialogStore, AddCoachMeetingDialogController],
})
export class AddCoachMeetingDialogComponent {
	public maxDate: Date;
	public minDate: Date;
	public coachee$: Observable<IUser>;
	public meetingDate$: Observable<Date>;
	public coacheeDateTime$: Observable<string>;
	public BASE_I18N_KEY = AddCoachMeetingDialogController.BASE_I18N_KEY;
	public modules$: Observable<SelectItem[]>;
	public isSaving$: Observable<boolean>;

	constructor(
		dialogConfig: DynamicDialogConfig,
		private _dialogRef: DynamicDialogRef,
		private _controller: AddCoachMeetingDialogController
	) {
		this.maxDate = DateTime.local().plus({ month: 3 }).toJSDate();
		this.minDate = DateTime.local().plus({ hour: 12 }).toJSDate();
		this.coacheeDateTime$ = _controller.coacheeDateTime$.pipe(
			map((d) => d.toFormat('f'))
		);
		_controller.updateCoacheeId(dialogConfig.data.coacheeId);
		this.meetingDate$ = _controller.meetingDate$;
		this.coachee$ = _controller.coachee$;
		this.modules$ = _controller.modules$;
		this.isSaving$ = _controller.isSaving$;
	}

	public onAddClick(): void {
		this._controller.addMeeting().subscribe(() => {
			this._dialogRef.close();
		});
	}

	public onMeetingDateChange(meetingDate: Date): void {
		this._controller.updateMeetingDate(meetingDate);
	}

	public onModulesIdSelected(e: { value: string[] }): void {
		this._controller.updateModulesId(e.value);
	}
}
